<template>
  <div class="app-tabbar">
    <div
      v-for="item in tabList"
      :key="item.pagePath"
      class="app-tabbar-item"
      :class="{ active: isActive(item) }"
      @click="switchTab(item)"
    >
      <div class="app-tabbar-icon-wrap">
        <van-icon
          :name="item.icon"
          size="24"
          :color="isActive(item) ? '#4b3f2f' : '#b0a898'"
        />
      </div>
      <span class="app-tabbar-text">{{ $t(item.text) }}</span>
    </div>
  </div>
</template>

<script>
import { TAB_BAR_LIST } from '@/config/tabbar'

export default {
  name: 'CommonTabbar',
  data() {
    return {
      tabList: TAB_BAR_LIST
    }
  },
  methods: {
    formatPath(path) {
      return path && path.startsWith('/') ? path : `/${path}`
    },
    isActive(item) {
      return this.$route.path === this.formatPath(item.pagePath)
    },
    switchTab(item) {
      if (item.disabled) return
      const url = this.formatPath(item.pagePath)
      if (this.$route.path === url) return
      uni.switchTab({ url })
    }
  }
}
</script>

<style scoped>
.app-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: stretch;
  height: 58px;
  padding-bottom: env(safe-area-inset-bottom);
  background: #fffdf9;
  border-top: 1.5px solid #e8dece;
  box-shadow: 0 -4px 16px rgba(70, 56, 41, 0.06);
}

.app-tabbar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #b0a898;
  cursor: pointer;
  transition: color 0.2s;
  position: relative;
}

.app-tabbar-item.active {
  color: #4b3f2f;
}

/* 激活时顶部指示线 */
.app-tabbar-item.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 2.5px;
  border-radius: 0 0 3px 3px;
  background: #4b3f2f;
}

.app-tabbar-icon-wrap {
  width: 36px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition: background 0.2s;
}

.app-tabbar-item.active .app-tabbar-icon-wrap {
  background: rgba(75, 63, 47, 0.1);
}

.app-tabbar-text {
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: color 0.2s;
}

.app-tabbar-item.active .app-tabbar-text {
  font-weight: 700;
}
</style>
